export default __webpack_public_path__ + "static/media/mobileRedirect.6c10c0e9.svg";